import { FileEntry, DirectoryEntry, DirectoryReader, Entry } from '@iris/common/models/FileSystem';
import { map, compact } from 'lodash';
import { of } from 'rxjs';

/**
 * Callback-free alternative for {@link FileEntry.file}
 * @param {FileEntry} fileEntry
 * @returns {Promise<File>}
 */
export const fileEntryGetFile = async (fileEntry: FileEntry): Promise<File> => {
  return await new Promise((resolve, reject) => fileEntry.file(resolve, reject));
};

/**
 * Callback-free alternative for {@link DirectoryReader.readEntries}
 * @param {DirectoryReader} reader
 * @returns {Promise<Entry[]>}
 */
export const readEntriesAsync = (reader: DirectoryReader): Promise<Entry[]> => {
  return new Promise((resolve, reject) => {
    reader.readEntries(
      entries => resolve(entries), error => reject(error),
    );
  });
};

export const getEntriesFromTransferItems = (dataTransferItems: DataTransferItemList): Entry[] => {
  return compact(map(dataTransferItems, item => item.webkitGetAsEntry() as Entry));
};

export const getDirectoriesEntries = (entries: Entry[]): DirectoryEntry[] => {
  return entries.filter(({ isDirectory }) => isDirectory) as DirectoryEntry[];
};

export const getFilesEntries = (entries: Entry[]): FileEntry[] => {
  return entries.filter(({ isFile }) => isFile) as FileEntry[];
};

export const hasDirEntryChildDir = (dirEntry: DirectoryEntry): Promise<boolean> => {
  if (!dirEntry) {
    return of(false).toPromise();
  }
  return readEntriesAsync(dirEntry.createReader())
    .then((entries) => {
      return entries.some((entry) => entry.isDirectory);
    });
};
